import resultHistoryService from '../../api/resultsHistory'
import notify from '../../api/notification'
import { downloadFileByByteArray } from '@/utils/convertByteArrayToFile'

const state = {
  resultsHistoryLoadingStatus: false,
  resultsHistoryFilters: {},
  resultsHistoryList: {},
  resultsHistoryDownloadModalStatus: false,
  resultsHistoryDownloadLoading: false,
  resultHistoryToExportInPDF: {}
}

const mutations = {
  setResultHistorySetLoadingStatus(state, resultsHistoryLoadingStatus) {
    state.resultsHistoryLoadingStatus = resultsHistoryLoadingStatus
  },
  setResultHistoryResultsList(state, resultsHistoryList) {
    state.resultsHistoryList = resultsHistoryList
  },
  setResultsHistoryFilters(state, resultsHistoryFilters) {
    state.resultsHistoryFilters = resultsHistoryFilters
  },
  setResultsHistoryModalStatus(state, resultsHistoryDownloadModalStatus) {
    state.resultsHistoryDownloadModalStatus = resultsHistoryDownloadModalStatus
  },
  setResultsHistoryDownloadLoading(state, resultsHistoryDownloadLoading) {
    state.resultsHistoryDownloadLoading = resultsHistoryDownloadLoading
  },
  setResultHistoryToExportInPDF(state, result) {
    state.resultHistoryToExportInPDF = result
  }
}

const getters = {
  resultsHistoryLoadingStatus: state => {
    return state.resultsHistoryLoadingStatus
  },
  resultsHistoryList: state => {
    return state.resultsHistoryList
  },
  resultsHistoryFilters: state => {
    return state.resultsHistoryFilters
  },
  resultsHistoryDownloadModalStatus: state => {
    return state.resultsHistoryDownloadModalStatus
  },
  resultsHistoryDownloadLoading: state => {
    return state.resultsHistoryDownloadLoading
  }
}

const actions = {
  getServiceResultsHistory: function ({ commit, state, rootState }) {
    commit('setResultHistorySetLoadingStatus', true)

    return resultHistoryService
      .getResultsHistoryByFilter(state.resultsHistoryFilters)
      .then(response => {
        commit('setResultHistorySetLoadingStatus', false)
        commit('setResultHistoryResultsList', response.data)
      })
      .catch(err => {
        let message = err.response.data.message
        if (!message || !message.includes('Acesso bloqueado')) {
          message = 'Não foi possível carregar os resultados.'
        }

        notify({
          title: 'AVISO:',
          message: message
        })

        if (rootState.profile.defaulter) {
          this.$store.commit('RESULT_SET_OVERDUE', true)
        }

        commit('setResultHistoryResultsList', [])
        commit('setResultHistorySetLoadingStatus', false)
      })
  },
  getResultsHistoryFilter: function ({ commit }, filters) {
    commit('setResultsHistoryFilters', filters)
  },
  changeStatusResultsHistoryModal: function ({ commit }, status) {
    commit('setResultsHistoryModalStatus', status)
  },
  exportResultHistoryInPDF: async function ({ commit }, result) {
    commit('setResultsHistoryDownloadLoading', true)
    try {
      const response = await resultHistoryService.downloadResultsHistory(result.id_order)
      const fileName = result.id_order
      const fileExtension = 'application/pdf'

      downloadFileByByteArray(response.data, fileName, fileExtension)
      commit('setResultsHistoryDownloadLoading', false)
      commit('setResultHistoryToExportInPDF', {})
    } catch (error) {
      console.error('Erro ao processar o PDF:', error)
      commit('setResultsHistoryDownloadLoading', false)
      notify({
        title: 'AVISO:',
        message: `Erro ao fazer download do PDF. Por favor, tente novamente.`
      })
    }
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
